export const prodConfig = {
  name: 'Production',
  baseUrl: 'https://word.v14.tools',
  apiUrl: 'https://word.v14.tools/api',
  // Traefik on word.v14.tools reverse-proxies /api/ai → the LiteLLM gateway
  // (see deploy/). Keeps the model calls same-origin, so there is no CORS.
  // Switch to 'direct' only if the add-in is hosted without that proxy (then
  // the gateway must allow the add-in's origin via CORS).
  aiProxy: 'same-origin' as const,
};
